// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import config from '../../../../share/config';
import loading from '../../../../share/components/vue/ProcessingIcon';
import { mapState } from 'vuex';
import logWrapper from '../../../../share/logWrapper';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      modelUpdateProcessing: true,
      turnIgOnChecked: false,
      processing: false,

      // 各種ダイアログのバインド値
      modalconfirmstartecuregistrationtype3: false,
      modalregisterecutype3igon: false,
      modalregisterecutype3igoff: false,
      modalregisterecutype3progress: false,
      modalregisterecutype3completed: false,
      modalregisterecutype3warning: false,
      modalregisterecutype3error: false,
    };
  },

  props: {
    onRegECUType3OkButtonClick: Function,
    IgOnType3OkButtonClick: Function,
    IgOnRetryType3OkButtonClick: Function,
    IgOnRetryType3WarningClose: Function,
    onErrorType3OkButtonClick: Function,
    imbStatusInfo: Object,
    onSetEndOfProcessingFlag: Function,
    isCausesAndActionDialog: Function,
    changeProcessingStatus: Function,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false }),
    },
    vehicleType: String
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      isEurope: state => state.userProperty.region === config.REGION_EUROPE,
      vehicle: state => state.vehicle,
    }),

    // ECU登録実行確認ダイアログの文言を決定
    genConfirmStartECURegistrationText() {
      const registerType = ["J"].includes(this.vehicleType) ? "hv_ecu_exec" : "ecu_exec_ecm";
      return this.AddUnderline(this.$t(`imb.register_${registerType}_reg_ensure_all_doors`));
    },

    // ECU登録中ダイアログの文言を決定
    genRegisterECUProgressText() {
      const ecuName = ["J"].includes(this.vehicleType) ? "hvecu" : "ecm";
      return this.$t(`imb.register_key_less_immobilizer_process_${ecuName}_reg`);
    }

  },

  watch: {
    processing: function (value) {
      this.changeProcessingStatus(value);
    },
    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    igOnOkButtonClick: async function () {
      await this.IgOnType3OkButtonClick();
      this.turnIgOnChecked = false;
    },
    igOnRetryButtonClick: async function () {
      await this.IgOnRetryType3OkButtonClick();
      this.turnIgOnChecked = false;
    },
    igOnWarningButtonClick: async function () {
      await this.IgOnRetryType3WarningClose();
      this.determineEndOfProcessingFlag();
    },
    AddUnderline: function (string) {
      return string.replace(/<br\/>.+/g, '<u>$&</u>');
    },
    errorOkButtonClick: async function () {
      this.processing = true;
      await this.onErrorType3OkButtonClick();
      this.processing = false;
      this.determineEndOfProcessingFlag();
    },
    successOkButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    cancelButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
    modalShowWEvent: function (mode) {
      const info = { id: this.modalShowInfo.id, isShow: false, nextModal: this.modalShowInfo.nextModal };
      if (mode === "show") {
        info.isShow = true;
      }
      this.$emit("modalDisplayStatus", info);
    },

    dialogCloseProcess: function () {
      const id = this.modalShowInfo.id.replace(/-/g, "");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
    }
  },

  created() { },

};